import OperationsGrossReport from "../../components/Operations/GrossReport/OperationsGrossReport";

const OperationsGrossReportPage = () => {
  return <OperationsGrossReport />;
};

export default OperationsGrossReportPage;
